import { Link } from "react-router-dom";

export default function NavBar() {
    return (
        <>
            <nav className="navbar">
                <div id="menu" className="menu">
                    <span id="blankspace" className="blankspace"></span>
                    <Link to={"./home"} className="item">{"<"}raulcrespoblog{"/>"}</Link>
                    {/* <a id="item" href="/home" className="item">
                        <img src="imgs/home/home.svg" alt={'Home button'} id="item-logo" className="item-logo"/>
                        <span className="item-label">home</span>
                    </a> */}
                    {/* TODO: Dark mode */}
                    {/* <a id="item" href="#" className="item" onClick="toggleMode(true)">
                        <img src="imgs/home/dark_mode.svg" alt={'Dark mode button'} id="item-logo" className="item-logo"/>
                        <span className="item-label">dark</span>
                    </a> */}
                    {/* <a id="item" href="./login.html" className="item">
                        <img src="imgs/home/about.svg" alt={'Login button'} id="item-logo" className="item-logo"/>
                        <span className="item-label">login</span>
                    </a> */}
                    <span id="blankspace" className="blankspace"></span>
                </div>
            </nav>
        </>
    )
}